/**
 * External dependencies
 */
import { useMemo } from 'react';

/**
 * Internal dependencies
 */
import AdminPageKey from '@naruto/bgdcms/src/base/routes/AdminPageKey';
import GuestPageKey from '@naruto/bgdcms/src/base/routes/GuestPageKey';

export interface usePageKey {
  guest: typeof GuestPageKey;
  admin: typeof AdminPageKey;
}

/**
 * 描述 : 取得頁面的 ID
 */

export default function usePageKey(): usePageKey {
  /* Main */
  return useMemo(
    () => ({
      guest: GuestPageKey,
      admin: AdminPageKey
    }),
    []
  );
}
